import React from 'react';
import ImagesAndCTA from './ImagesAndCTA';
import styles from "./NewCollection.module.sass";

const NewCollection = () => {
  return (
    <>
      <div className={styles.row}>
        <div className={styles.col}>
          <ImagesAndCTA className={styles.card} />
        </div>
      </div>
    </>
  )
}

export default NewCollection